module.exports = __webpack_public_path__ + "img/airwallex.ccecd7bb.png";